module.exports = __webpack_public_path__ + "static/media/28.dd9ef349.mp3";